import { render } from "./Administrativo.vue?vue&type=template&id=42c9f57d"
import script from "./Administrativo.vue?vue&type=script&lang=js"
export * from "./Administrativo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__